import { render, staticRenderFns } from "./TheHome.vue?vue&type=template&id=e61e35fa&scoped=true"
import script from "./TheHome.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheHome.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TheHome.vue?vue&type=style&index=0&id=e61e35fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61e35fa",
  null
  
)

export default component.exports